import React from 'react';
import { X, Download, Share } from 'lucide-react';
import { usePWA } from '../../hooks';

export function InstallBanner() {
  const { showBanner, isIOS, promptInstall, dismissBanner } = usePWA();

  if (!showBanner) {
    return null;
  }

  const handleInstall = async () => {
    if (isIOS) {
      // On iOS, we can't programmatically trigger install
      // Just dismiss the banner - the instructions are shown
      dismissBanner();
    } else {
      await promptInstall();
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up">
      <div className="bg-indigo-600 text-white px-4 py-3 shadow-lg">
        <div className="max-w-md mx-auto flex items-center gap-3">
          {/* App Icon */}
          <div className="flex-shrink-0 w-12 h-12 bg-white rounded-xl flex items-center justify-content overflow-hidden">
            <img
              src="/icons/icon-192x192.png"
              alt="GoodPlace"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Text Content */}
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-sm">GoodPlace installieren</p>
            {isIOS ? (
              <p className="text-xs text-indigo-200 flex items-center gap-1">
                <Share className="w-3 h-3 inline" /> Teilen, dann "Zum Home-Bildschirm"
              </p>
            ) : (
              <p className="text-xs text-indigo-200">Schneller Zugriff von deinem Homescreen</p>
            )}
          </div>

          {/* Install Button */}
          {!isIOS && (
            <button
              onClick={handleInstall}
              className="flex-shrink-0 bg-white text-indigo-600 px-3 py-1.5 rounded-full text-sm font-semibold hover:bg-indigo-50 transition-colors flex items-center gap-1"
            >
              <Download className="w-4 h-4" />
              <span className="hidden sm:inline">Installieren</span>
            </button>
          )}

          {/* Close Button */}
          <button
            onClick={dismissBanner}
            className="flex-shrink-0 p-1 hover:bg-indigo-500 rounded-full transition-colors"
            aria-label="Schliessen"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default InstallBanner;
